module.exports = __webpack_public_path__ + "img/heroImage.b8ffd04e.png";